import { useMutation } from "react-query";
import getLoanForVerification from "../services/getLoanForVerification";

const useGetLoanForVerification = () => {
  return useMutation(["get-loan-for-verification"], getLoanForVerification);
};

export default useGetLoanForVerification;
